import { getDataMapper, mapField } from "@/shared";

export const mapRepairFiltersToServer = getDataMapper({
    admin_user_id: mapField("employee", (employee) => employee?.userId ?? null),
    inventory_id: mapField("inventory", (inventory) => {
        return inventory?.id != null ? Number(inventory.id) : null;
    }),
    outer_inventory: mapField("outerInventory", Boolean),
    repair_state_id: mapField("repairStatuses", (s) => {
        return s?.id != null ? Number(s.id) : null;
    }),
});
